import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';

import CrossSellingList from './list/crossSellingList';
import EditCrossSelling from './editCrossSelling';
import PageError from '../../error/pageError';

export default function CrossSellingsRouter({ organization, path }) {
    return (
        <Switch>
            <Route exact allow={[]} path={`${path}`} render={() => <CrossSellingList organization={organization} />} />
            <Route exact allow={[]} path={`${path}/add`} render={() => <EditCrossSelling organization={organization} />} />
            <Route
                exact
                allow={[]}
                path={`${path}/edit/:productId([0-9]+)`}
                render={basenameProps => <EditCrossSelling productId={basenameProps.match.params.productId} organization={organization} />}
            />
            <Route
                exact
                allow={[]}
                path={`${path}/edit/:productId([0-9]+)/page/:page([0-9]+)`}
                render={basenameProps => <EditCrossSelling page={basenameProps.match.params.page} productId={basenameProps.match.params.productId} organization={organization} />}
            />

            {/* Error */}
            <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}`} />} />
        </Switch>
    );
}

CrossSellingsRouter.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
